import EditAlertPriorityModal from "./EditAlertPriorityModal";

export default EditAlertPriorityModal